import { render, staticRenderFns } from "./OfertasView.vue?vue&type=template&id=4a4b0a23&scoped=true"
import script from "./OfertasView.vue?vue&type=script&lang=js"
export * from "./OfertasView.vue?vue&type=script&lang=js"
import style0 from "./OfertasView.vue?vue&type=style&index=0&id=4a4b0a23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4b0a23",
  null
  
)

export default component.exports